
import { defineComponent, onMounted } from 'vue';
import { RedirectLoginOptions } from '@auth0/auth0-spa-js';
import './signup-v2.css';
import { getAuthInstance } from '../../../auth/authService';

export default defineComponent({
    name: 'LoginScreen',
    setup() {
        onMounted(async () => {
            const auth = getAuthInstance();
            // Carry an email through when the wizard or a link supplies one, so
            // the hosted form arrives pre-filled.
            const hint = new URLSearchParams(window.location.search).get('email');
            const options: RedirectLoginOptions = hint ? { login_hint: hint } : {};
            await auth.loginWithRedirect(options);
        });

        return {
            logoLight: require('../../../assets/images/signup-v2/ditto-mark-white.svg')
        };
    }
});
